import { Component, OnInit } from '@angular/core';
import { selectImageByType } from 'src/utils/helpers';
import { NOTIFICATIONS_TABS } from 'src/utils/constants';
import { AuthService } from '@app/auth/services';
import { INotification, IPaginationParams } from 'src/utils/declarations';
import { PageEvent } from '@angular/material/paginator';
import { Store, select } from '@ngrx/store';
import * as fromNotificationStore from '@app/notifications/store';
import { Observable } from 'rxjs';
import { INotificationsContainerInfo } from '@app/notifications/store/reducers/notifications.reducers';

@Component({
  selector: 'app-notification-container',
  templateUrl: './notification-container.component.html',
  styleUrls: ['./notification-container.component.scss'],
})
export class NotificationContainerComponent implements OnInit {
  menuActive: string = 'meeting';
  activeNotifications: number[] = [];
  tabs = NOTIFICATIONS_TABS;
  totalElements: number = 0;
  pageSize = 10;
  currentNotification: INotification;
  public notificationsInfo$: Observable<INotificationsContainerInfo> =
    this.notificationsStore.pipe(
      select(fromNotificationStore.getContainerInfo)
    );
  selectItemImageByType = selectImageByType;

  constructor(
    private authService: AuthService,
    private notificationsStore: Store<fromNotificationStore.State>
  ) {}

  ngOnInit(): void {
    this.getNotifications({ page: 1, per_page: this.pageSize });
  }

  private getNotifications(params: IPaginationParams) {
    const { page, per_page } = params;

    this.notificationsStore.dispatch(
      new fromNotificationStore.GetContainerNotifications({
        page,
        per_page,
        token: this.authService.getToken(),
      })
    );

    this.notificationsInfo$.subscribe((resp) => {
      this.totalElements = resp.total;
    });
  }

  nextPage(event: PageEvent) {
    const request: IPaginationParams = {
      page: event.pageIndex + 1,
      per_page: this.pageSize,
    };
    this.getNotifications(request);
  }

  checkActive(id: number) {
    return this.activeNotifications.some((n) => n === id);
  }

  openNotification(id: number) {
    this.notificationsInfo$.subscribe((resp) => {
      this.currentNotification = resp.data.find(
        (n) => n.id === id
      ) as INotification;
    });

    if (
      this.currentNotification &&
      !this.activeNotifications.some((n) => n === id)
    ) {
      // check that notification isn't readed
      if (!this.currentNotification.read) {
        this.notificationsStore.dispatch(
          new fromNotificationStore.ReadOneNotification({
            id,
            token: this.authService.getToken(),
          })
        );
      }
    }

    if (this.activeNotifications.some((n) => n === id)) {
      this.activeNotifications = this.activeNotifications.filter((e) => {
        return e !== id;
      });
    } else {
      this.activeNotifications.push(id);
    }
  }
}
